import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { DsButtonComponent } from '@alarislabs/angular-components/button';
import { DsIconSwapComponent } from '@alarislabs/angular-components/icon-swap';

@Component({
	selector: 'app-table-management',
	templateUrl: './table-management.component.html',
	styleUrl: './table-management.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [DsIconSwapComponent, DsButtonComponent, TranslateModule],
})
export class TableManagementComponent {
	refresh = input<() => void>(() => {});
	export = input<() => void>(() => {});
	loading = input<boolean>(false);
}
